/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import { authenticateUser } from '@/lib/auth/authenticate'
import { DialogPopup, DialogPopupType } from '@/components/ui/DialogPopup'
import { useTranslation } from '@/i18n/client_hook'
import { defaultNS } from '@/i18n/settings'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

type AuthParams = {
    oauth_error: string|undefined
    error_title: string|undefined,
    error_msg: string|undefined,
    error_stop_redirect: boolean,
    code: string|undefined,
    state: string|undefined
}

export const Route = createFileRoute('/authenticate')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): AuthParams => {
    return {
      oauth_error: search.oauth_error as string|undefined,
      error_title: search.error_title as string|undefined,
      error_msg: search.error_msg as string|undefined,
      error_stop_redirect: search.error_stop_redirect === undefined ? false : search.error_stop_redirect as boolean,
      code: search.code as string|undefined,
      state: search.state as string|undefined,
    };
  },
})

function RouteComponent() {
  const { t } = useTranslation(defaultNS);
  const {
    oauth_error,
    error_title,
    error_msg,
    error_stop_redirect,
    code,
    state
  } = Route.useSearch();

  useEffect(() => {
    (async () => {
      const next_url:URL = await authenticateUser(
        oauth_error,
        error_title,
        error_msg,
        error_stop_redirect,
        code,
        state
      );
      window.location.href = next_url.toString();
    })()
  })

  return <div>
    <DialogPopup
      message={t("auth.logging_in_msg")}
      type={DialogPopupType.NoButtons}
    />
  </div>
}
